<template>
    <b-card no-body class="bg-info" :class="[ item.class ]">
    <b-card-body class="pb-0">
        <b-dropdown class="float-right" variant="transparent p-0" right>
        <template slot="button-content">
            <i class="icon-settings"></i>
        </template>
        <!--
        <b-dropdown-item v-if="type === 1" :to="{ path: '/changecontrol/changereturn', query: { operator_username: item.operatorName, operator_user: item.operatorCode, control_value: item.total } }">Entrada / Retorno</b-dropdown-item>
        <b-dropdown-item v-if="type === 2" :to="{ path: '/changecontrol/changereturn', query: { operator_username: item.operatorName, operator_user: item.operatorCode, control_value: item.total } }">Aprovar Devolução</b-dropdown-item>
        -->
        <b-dropdown-item v-if="type === 1" :to="{ path: '/changecontrol/changereturn', query: { movement_id: item.id } }">Retorno</b-dropdown-item>
        <b-dropdown-item v-if="type === 2" :to="{ path: '/changecontrol/changereturn', query: { movement_id: item.id } }">Aprovar Retorno</b-dropdown-item>
        </b-dropdown>
        <p>{{ new Date(item.startDate).toLocaleString().slice(0,16) }}
        <h5 class="mb-0">{{ item.operatorName }}</h5>
        <p>{{ item.operatorCode }}
        </p>
        <h4 class="mb-0"><small>R$ </small> {{ $utils.numberFormat(item.total) }}</h4>
        <p></p>
    </b-card-body>
    </b-card>
</template>

<script>
export default {
  name: "ChangeControlItemComponent",
  props: {
    controlitem: Object,
    controltype: Number
  },
  data() {
    return {
      item: this.controlitem,
      type: this.controltype
    }
  },
  methods: {
    
  }   
};

</script>
